angular.module('NumbersEditor')
    .factory('SettingFactory', [
        '$http', function($http) {

            var urlBase = '/api/Setting';
            var settingFactory = {};

            settingFactory.GetAll = function() {
                return $http.get(urlBase);
            };

            settingFactory.GetById = function(id) {
                return $http.get(urlBase + "/" + id);
            };

            settingFactory.Save = function (setting) {
                return $http.post(urlBase ,setting);
            };

            settingFactory.Update = function (setting) {
                return $http.put(urlBase,setting );
            };

            return settingFactory;
        }
    ]);